import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';
import { useCardContext } from '../card-context/card-context.esm.js';

var _excluded = ["children", "actions", "className", "gap"];
var CardHeader = /*#__PURE__*/forwardRef(function CardHeader(props, ref) {
  var theme = useComponentTheme('Card');
  var children = props.children,
    actions = props.actions,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'lg' : _props$gap,
    rest = _objectWithoutProperties(props, _excluded);
  var _useCardContext = useCardContext(),
    padding = _useCardContext.padding,
    radius = _useCardContext.radius,
    withDivider = _useCardContext.withDivider;
  // const id = usePropId(props.id)
  var classes = useMemo(function () {
    return theme.header({
      gap: gap,
      padding: padding,
      radius: radius,
      withDivider: !!withDivider,
      className: className
    });
  }, [theme, gap, padding, className, radius, withDivider]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    // id={id}
    ref: ref,
    className: "csg-tw-card-header ".concat(classes)
  }, rest), children, actions ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, actions) : null);
});
CardHeader.displayName = 'Card.Header';
var CardHeader$1 = CardHeader;

export { CardHeader$1 as default };
//# sourceMappingURL=card-header.esm.js.map
